import { useRequest } from 'ahooks';
import { useEffect, useMemo, useState } from 'react';
import { getAuthTypeBase, getValueByName } from 'src/api/common';
import { getAuditStatus, getReleaseStatus, getRightStatus } from 'src/api/dataSearch';
import { getPrizeTypeList } from 'src/api/distribution';
import ConfigurationContext from 'src/context/configuration';
import { createOpts } from 'src/utils/config';

const ConfigProvider = ({ children }) => {
  const userInfo = sessionStorage.getItem('USER_BASE_INFO');
  const [isHF, setIsHF] = useState(false);

  /**全局权益状态 */
  const { data: rightStatusMap, runAsync: getRightStatusMap } = useRequest(getRightStatus, {
    manual: true,
  });

  /**全局发放状态 */
  const { data: releaseStatusMap, runAsync: getReleaseStatusMap } = useRequest(getReleaseStatus, {
    manual: true,
  });

  /**全局审核状态 */
  const { data: auditStatusMap, runAsync: getAuditStatusMap } = useRequest(getAuditStatus, {
    manual: true,
  });

  /**全局名单认证方式 */
  const { data: authTypeOptions, runAsync: getAuthTypeBaseMap } = useRequest(getAuthTypeBase, {
    manual: true,
  });

  const { data: prizeTypeList = [], run: getPrizeType } = useRequest(getPrizeTypeList, {
    manual: true,
  });

  //HF特定账号特殊逻辑
  useRequest(() => getValueByName(`account_platform_type:${JSON.parse(userInfo)?.id}`), {
    onSuccess: (res) => setIsHF(res === 'HF'),
  });

  const templateIdMap = useMemo(() => {
    return authTypeOptions?.reduce((pre, cur) => {
      pre[cur.value] = cur.label;
      return pre;
    }, {});
  }, [authTypeOptions]);

  const prizeTypeMap = useMemo(() => {
    const map = {};
    (prizeTypeList || []).forEach((i) => {
      map[i.value] = i.label;
    });
    return map;
  }, [prizeTypeList]);

  const initCommonUseData = async () => {
    const orgId = JSON.parse(userInfo)?.orgId;
    getPrizeType({ orgId });
    await getRightStatusMap();
    await getReleaseStatusMap();
    await getAuditStatusMap();
    await getAuthTypeBaseMap();
  };

  useEffect(() => {
    if (userInfo) {
      initCommonUseData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = {
    rightStatusMap,
    rightStatusOptions: createOpts(rightStatusMap),
    releaseStatusMap,
    releaseStatusOptions: createOpts(releaseStatusMap),
    auditStatusMap,
    templateIdMap,
    auditStatusOptions: createOpts(auditStatusMap),
    authTypeOptions,
    initCommonUseData,
    prizeTypeList,
    prizeTypeMap,
    isHF,
  };

  return <ConfigurationContext.Provider value={value}>{children}</ConfigurationContext.Provider>;
};

/**
 *
 *@returns
 */

export default ConfigProvider;
